/* bs-about-values — animación count-up de los stats al entrar en viewport.
   Parsea formato español: "+15", "+50.000", "4,9", "+3.000".
   Preserva prefijo (+) y mantiene formato (puntos miles, coma decimal). */

(function () {
  'use strict';

  function parseValue(str) {
    var trimmed = String(str).trim();
    var prefixMatch = trimmed.match(/^[^\d-]*/);
    var prefix = prefixMatch ? prefixMatch[0] : '';
    var numPart = trimmed.slice(prefix.length);
    var decimals = 0;
    var value = 0;
    if (numPart.indexOf(',') !== -1) {
      // Coma = separador decimal (español)
      var parts = numPart.split(',');
      var intClean = parts[0].replace(/\./g, '');
      decimals = parts[1].length;
      value = parseFloat(intClean + '.' + parts[1]);
    } else {
      // Solo puntos = separador de miles
      var clean = numPart.replace(/\./g, '');
      value = parseInt(clean, 10);
    }
    if (isNaN(value)) value = 0;
    return { prefix: prefix, value: value, decimals: decimals };
  }

  function formatValue(value, decimals) {
    if (decimals > 0) {
      return value.toFixed(decimals).replace('.', ',');
    }
    return Math.floor(value).toLocaleString('es-ES');
  }

  function animateStat(el, target, prefix, decimals, duration) {
    var startTime = performance.now();
    function step(now) {
      var elapsed = now - startTime;
      var progress = Math.min(elapsed / duration, 1);
      // ease-out cubic
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = target * eased;
      el.textContent = prefix + formatValue(current, decimals);
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function setupStat(el) {
    if (el.__bsAboutValuesInit) return;
    el.__bsAboutValuesInit = true;
    var original = el.textContent;
    var parsed = parseValue(original);
    // Guarda valor original para repeat si fuera necesario, y resetea a 0 con formato
    el.setAttribute('data-bs-target', original);
    el.textContent = parsed.prefix + formatValue(0, parsed.decimals);
    return parsed;
  }

  function init(root) {
    var stats = (root || document).querySelectorAll('.bs-about-values__stat-value');
    if (!stats.length) return;

    // Si el usuario prefiere reduced-motion, mostrar el valor final sin animación
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      stats.forEach(function (el) {
        if (el.__bsAboutValuesInit) return;
        el.__bsAboutValuesInit = true;
      });
      return;
    }

    if (!('IntersectionObserver' in window)) {
      // Fallback: animar todos al cargar
      stats.forEach(function (el) {
        var p = setupStat(el);
        if (p) animateStat(el, p.value, p.prefix, p.decimals, 1500);
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var p = setupStat(el);
        if (!p) return;
        animateStat(el, p.value, p.prefix, p.decimals, 1500);
        observer.unobserve(el);
      });
    }, { threshold: 0.4 });

    stats.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('.bs-about-values')) init(event.target);
  });
})();
